import FollowCamera, { FollowPhase } from "./follow_camera";
import BoneFetchController from "./bone_fetch_controller";
import DioramaCamera from "../../../lib/services/scene/diorama_camera";
import DioramaCameraControl from "../../../lib/services/scene/diorama_camera_control";
import Puppy from "./puppy";

export default class BoneFollowCamera extends FollowCamera {
  private boneFetch: BoneFetchController;

  constructor(
    camera: DioramaCamera,
    cameraControl: DioramaCameraControl,
    puppy: Puppy,
    boneFetch: BoneFetchController
  ) {
    super(camera, cameraControl, puppy);
    this.boneFetch = boneFetch;
  }

  protected getPhase(): FollowPhase {
    const phase = this.boneFetch.get_phase();

    if (phase === "running_to_bone") return "outbound";
    if (phase === "returning_to_eat_spot") return "returning";
    return "idle";
  }

  protected updateFollowCamera(phase: FollowPhase, _deltaTime: number): void {
    const puppyPos = this.puppy.transform.position;

    if (phase === "outbound") {
      const targetX = puppyPos[0] + 0.6;
      const targetZ = puppyPos[2] - 0.15;

      this.camera.follow_xz(targetX, targetZ, 0.08);
      this.camera.set_target(this.camera.target[0], 0.55, this.camera.target[2]);
      this.camera.set_distance(7.0);
      return;
    }

    const eatX = 0.5132098197937012;
    const eatZ = 6.010136127471924;

    const targetX = puppyPos[0] * 0.65 + eatX * 0.35;
    const targetZ = puppyPos[2] * 0.65 + eatZ * 0.35;

    this.camera.follow_xz(targetX, targetZ, 0.08);
    this.camera.set_target(this.camera.target[0], 0.55, this.camera.target[2]);
    this.camera.set_distance(6.4);
  }
}